import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopDiscount(props) {
  const {open, close} = props;

  return (
    <Modal open={open} close={close} popSize="s" type="com_input pop_discount">
      <h2 className="pop_tit">상품 할인하기</h2>
      <div className="content_container scroll">
        <hr className="com_divider" />
        <div className="check com_radio_wrap gap">
          <input type="radio" name="rdo_1" id="rdo02" className="com_chk circle" />
          <label htmlFor="rdo02">논술</label>
          <input type="radio" name="rdo_1" id="rdo03" className="com_chk circle" />
          <label htmlFor="rdo03">생기부디자인</label>
          <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
          <label htmlFor="rdo04">정시컨설팅 </label>
          <input type="radio" name="rdo_1" id="rdo05" className="com_chk circle" />
          <label htmlFor="rdo05">수시컨설팅</label>
          <input type="radio" name="rdo_1" id="rdo06" className="com_chk circle" />
          <label htmlFor="rdo06">면접</label>
          <input type="radio" name="rdo_1" id="rdo07" className="com_chk circle" />
          <label htmlFor="rdo07">자소서</label>
        </div>
        <table className="com_board_list type_row">
          <colgroup>
            <col width="148" />
            <col width="auto" />
          </colgroup>
          <tbody>
            <tr>
              <th>상품 선택</th>
              <td>
                <select name="" id="" className="select">
                  <option value="">논술 세트상품 60</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>할인 상품명</th>
              <td>
                <div className="com_input_wrap">
                  <input type="text" className="input wl" defaultValue={`논술 세트상품 60 (할인)`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>상품가격</th>
              <td>70,000</td>
            </tr>
            <tr>
              <th>할인율(%)</th>
              <td>
                <input type="text" className="input" defaultValue={`10`} />
              </td>
            </tr>
            <tr>
              <th>할인 가격</th>
              <td>70,000</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
        <button className="com_btn gray xs">상품삭제</button>
      </div>
    </Modal>
  );
}

export default PopDiscount;
